import React, { lazy } from 'react';
import moment from 'moment';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const PotentialViolations = ({ potentialViolations, i18n }) => {
  const columns = checkServiceProvider('potentialViolations_columns', window.$environment.SERVICE_PROVIDER, false);

  const generateRows = () => {
    return potentialViolations?.map((item) => ({
      driver: item.items[0],
      id: item.items[1],
      phone: item.items[2],
      violationType: item.items[3],
      date: item.items[4] ? moment(new Date(item.items[4])).format('MM/DD/YYYY hh:mm:ss') : '',
    }));
  };

  return (
    <>
      <Table
        type="client"
        title=""
        columns={[...columns]}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        actions={[]}
        i18n={i18n}
        noPagination
        id="potentialDashboard"
      />
    </>
  );
};

export default PotentialViolations;

PotentialViolations.defaultProps = {};

PotentialViolations.propTypes = {};
